import './chart-tree.scss';

/**
 * version    1.0
 * class      <type> (ChartTree)
 */
export class ChartTree {}
